import React from 'react';
import { useNavigate } from 'react-router-dom';
import { products, formatPrice } from '../data/products';
import './ProductsScreen.css';

export default function ProductsScreen() {
  const navigate = useNavigate();

  return (
    <div className="products-container">
      <div className="products-grid">
        {products.map((product) => (
          <div
            key={product.id}
            className="product-card"
            onClick={() => navigate(`/product/${product.id}`)}
          >
            <img src={product.imageUrl} alt={product.title} className="product-image" />
            <div className="product-info">
              <h3 className="product-title">{product.title}</h3>
              <p className="product-price">{formatPrice(product.priceCents)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
